function Modal({ isOpen, onClose, children }) {
  if (!isOpen) {
    return null;
  }
  return (
    <div className="modal">
      <div className="modal__overlay"></div>
      <div className="modal__content">{children}</div>
    </div>
  );
}

export default Modal;
